import {createTheme, responsiveFontSizes} from '@mui/material';
import CopperPlate from './Copperplate/CopperPlate.ttf';
export const theme = responsiveFontSizes(createTheme({
    palette: {
        primary: {
            main: "#FFF"
        },
        secondary: {
            main: "#000"
        }
    },
        typography:{
            fontFamily: [
                'Sans-Serif',
                'CopperPlate',   
            ].join('.'),
            SectionHeader: {
                color:"white", backgroundColor:"#2b388f", justifyContent:"center", display:"flex", fontSize:"5rem"}
        },
        components: {
            MuiCssBaseline: {
              styleOverrides: `
                @font-face {
                  font-family: 'CopperPlate';
                  font-style: normal;
                  font-display: swap;
                  font-weight: 500;
                  src: local('CopperPlate'), local('CopperPlate-Regular'), url(${CopperPlate}) format('truetype');
                  unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
                }`,   
            }
        }
}));